import styledComp from 'styled-components';
import {
  FormControl, Avatar, Tooltip, Theme,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styling } from '../../../../constants';

const teamSize = 24;

export const ProgressContainer = styledComp.div`
  height: 4px;
`;

export const StyledAvatar = styledComp(Avatar)`
  width: ${teamSize}px !important;
  height: ${teamSize}px !important;
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;

export const TeamContainer = styledComp.div`
  margin-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
  align-items: center;
  display: flex;
  height: ${teamSize * 2}px;
  justify-content: space-between;
  & > div {
    font-size: 1.15rem;
    display: flex;
    align-items: center;
  } 
  & > span {
    height: 18px;
    font-size: 1.05rem;
    text-overflow: ellipsis; 
    white-space: nowrap;
    overflow: hidden;
  }
  & > span, & > div {
    flex-grow: 1;
    flex-basis: 0;
  }
`;

export const TeamsContainer = styledComp.div`
  overflow-y: auto;
  padding: ${Styling.DEFAULT_SPACING}px;
`;

export const TextFilterContainer = styledComp.div`
  padding: 0 ${Styling.DEFAULT_SPACING}px;
`;

export const StyledToolTip = withStyles((theme: Theme) => ({
  tooltip: {
    fontSize: '1.05rem',
  },
}))(Tooltip);
